module.exports = __webpack_public_path__ + "static/Navegando-38e76c5be813008f56683f30170239f6.webp";